import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  catchError,
  debounceTime,
  map,
  Observable,
  of,
  Subject,
  Subscription,
} from 'rxjs';
import { SeoService } from '../../seo.service';
import { TranslateService } from '@ngx-translate/core';
// import { Router } from '@angular/router';
// import { SidenavService } from 'src/app/sidenav/sidenav.service';
// import { SidenavComponent } from 'src/app/sidenav/sidenav.component';
// import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MeetingsPopupComponent } from '../../modals/meetings-popup/meetings-popup.component';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-sharable-audit',
  templateUrl: './shareable-audit.component.html',
  styleUrls: [
    '../../../sidenav/sidenav.component.css',
    '../ai-analysis.component.css',
    '../../projects-page/projects-page.component.css',
    '../../../diagnostics/overall/overall.component.css',
    '../tasks-simplified/tasks-simplified.component.css',
    './shareable-audit.component.css',
  ],
})
export class SharableAuditComponent implements OnInit, OnDestroy {
  constructor(
    private seoService: SeoService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public media: MediaMatcher,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 1200px)');
  }
  private token: string = '';
  private subs: Subscription = new Subscription();

  public firstLoad: any = true;
  public showDummyData = false;
  public isLoading = false;

  public selected_search_option: string = 'Keyword';
  public selected_search_input: string = '';
  public selected_search_input_autofill: string = '';
  public selected_search_suggested_texts: any = [];
  public keyword_inputSubject = new Subject<string>();
  public keyword_input_placehodler: string = '';
  public url_input_placehodler: string = '';

  public allProjects: any = [];
  public selectedProject: any = {};
  public selectedProjectURL: any = '';
  public selectedProjectDomain: any = '';

  public selectedModel: any = 'view_all';
  public selectedModelObj: any = {
    name: 'Google',
    value: 'view_all',
    icon: '../../../assets/img/icons/google-logo.svg',
  };

  public modelCardsData: any = [
    {
      name: 'SERP Performance',
      description:
        'Legacy search methods declining in effectiveness compared to AI-driven approaches',
      icon: {
        src: '../../../assets/img/icons/google-logo.svg',
        alt: 'SERP Performance',
        hasDarkMode: false,
      },
      selected: false,
      value: 'view_all',
      score: 0,
      backend_key: 'traditional_search',
    },
    {
      name: 'ChatGPT Performance',
      description:
        "OpenAI's AI model showing steady improvement in search relevance and accuracy",
      icon: {
        src: '../../../assets/img/icons/openai-logo.svg',
        alt: 'ChatGPT Performance',
        hasDarkMode: true,
      },
      selected: false,
      value: 'chatgpt',
      score: 0,
      backend_key: 'gpt_performance',
    },
    {
      name: 'Gemini Performance',
      description:
        "Google's AI model showing steady improvement in search relevance and accuracy",
      icon: {
        src: '../../../assets/img/icons/gemini-logo.svg',
        alt: 'Gemini Performance',
        hasDarkMode: false,
      },
      selected: false,
      value: 'gemini',
      score: 0,
      backend_key: 'gemini_performance',
    },
  ];

  public contentStrengthOverviewDataDescriptionMAP: any = [
    {
      max: 49,
      description: 'Needs stronger content',
    },
    {
      max: 89,
      description: 'Decent content, room to grow',
    },
    {
      max: 100,
      description: 'Strong content driving engagement',
    },
  ];
  public linkStrengthOverviewDataDescriptionMAP: any = [
    {
      max: 49,
      description: 'Weak backlink profile',
    },
    {
      max: 89,
      description: 'Some backlinks, could improve',
    },
    {
      max: 100,
      description: 'Solid backlink authority',
    },
  ];
  public siteStrengthOverviewDataDescriptionMAP: any = [
    {
      max: 49,
      description: 'Technical issues affecting site',
    },
    {
      max: 89,
      description: 'Acceptable performance, minor fixes needed',
    },
    {
      max: 100,
      description: 'Excellent technical performance',
    },
  ];

  public progressChartStyleObj: any = {
    strokeWidth: 4,
    width: window.innerWidth < 1441 ? 70 : 80,
    height: window.innerWidth < 1441 ? 70 : 80,
    valueFontSize: window.innerWidth < 1441 ? '16px' : '20px',
    titleBottom: true,
    unit: '%',
  };

  public meetingsDialogRef: MatDialogRef<MeetingsPopupComponent>;

  public siteStrengthOverviewData: any = [
    {
      value: 0,
      title: 'Content Strength',
      description: 'High-quality content driving engagement',
      style: this.progressChartStyleObj,
      backend_key: 'content_strength',
      getDescription: () => {
        return this.contentStrengthOverviewDataDescriptionMAP.find(
          (item: any) => item.max >= this.siteStrengthOverviewData[0].value
        )?.description;
      },
    },
    {
      value: 0,
      title: 'Link Strength',
      description: 'Backlink profile needs improvement',
      style: this.progressChartStyleObj,
      backend_key: 'link_health',
      getDescription: () => {
        return this.linkStrengthOverviewDataDescriptionMAP.find(
          (item: any) => item.max >= this.siteStrengthOverviewData[1].value
        )?.description;
      },
    },
    {
      value: 0,
      title: 'Site Health',
      description: 'Excellent technical performance',
      style: this.progressChartStyleObj,
      backend_key: 'site_health',
      getDescription: () => {
        return this.siteStrengthOverviewDataDescriptionMAP.find(
          (item: any) => item.max >= this.siteStrengthOverviewData[2].value
        )?.description;
      },
    },
  ];

  public quick_wins_array: any = [];
  public content_score_fixes: any = [];
  public backlink_score_fixes: any = [];

  public page_bins: any = [];
  public page_bins_lines: any = ['0', '1', '2', '3', '4'];
  public backlink_bins: any = [];

  public cardName: string = `all_KPI_s`;
  public keywordDataInsights: any;
  public barChartOutputData: any = {};
  public overviewBarChartOutputData: any = {};
  public cardData: any;
  public selectedCard = 'All KPIs';
  public keywordData: any;
  public competitorExists: boolean = false;

  public horizontalSingleSelectOptions: any = [
    {
      value: 'you',
      viewValue: 'You',
      selected: true,
      format: 'short',
    },
    {
      value: 'competitor',
      viewValue: 'Competitor',
      selected: false,
    },
  ];
  public horizontalSingleOptionStyles = {
    width: innerWidth < 1441 ? '35px' : '40px',
    transform: '0px',
  };

  public renamedVariables: any;
  public renamedVariables_positive: any;
  public renamed_variables: any;
  public renamed_variables_2: any;
  public rename_variables_positive: any;
  public selectedObject: any;
  public selectedLanguage: string = 'en';
  public selectedCompetitor: string = '';

  public quick_wins: any = {};

  public cardsData: any = [
    {
      name: "All KPI's",
      value: 0,
      selected: false,
      competitor: 0,
    },
  ];

  public modelCardsDataDescriptionMAP: any = [
    {
      max: 30,
      description:
        'Barely showing up — performance is very limited and visibility is low',
    },
    {
      max: 60,
      description:
        'Starting to show up more often — performance is improving but still inconsistent',
    },
    {
      max: 80,
      description:
        'Showing up regularly — performance is strong and visibility is reliable',
    },
    {
      max: 100,
      description:
        'Always showing up — performance is excellent and visibility is very high',
    },
  ];

  public formatted_barchartInputDataPageIndex: number = 1;
  public formatted_barchartInputData_items_per_page: number = 4;
  public formatted_barchartInputData: any = [];
  public all_formatted_barchartInputData: any = [];

  public clickedFactor: any = null;
  public showNameClickedFactor = '';

  public backLinkselectedVariable: any = '';
  public showBacklinkOnlyTable: boolean = false;
  public showInternalLinkOnlyTable: boolean = false;
  public backlinkRelevanceTableActive: boolean = false;
  public isFirstExecution: boolean = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  // pagination
  public dataSource = new MatTableDataSource<any>();
  public pageIndex: number = 0;
  public pageSize: number = 10;
  public pageSizeOptions: number[] = [5, 10, 25, 100];
  public selectDomainOption: string = 'Show All';
  public isLoadingBacklinkTable: boolean = false;
  public selectedFilterButton: any = 'you';

  public show_ai_score_column: boolean = false;
  public numberOfShownElement: number = 3;
  public internalLinkingDataTable: any = [];

  public internalTotalCount: any;
  public backlinkTotalCount: any;

  public backlinkOnlyTableData: any = [];
  public tableVarianleOne: string = '';
  public tableVarianleTwo: string = '';

  public activeFilter: any = 'showAll';
  public filters: any = [
    {
      text: 'Show All',
      value: 'showAll',
      active: true,
    },
    {
      text: 'Content Relevance',
      value: 'contentRelevance',
      active: false,
    },
    {
      text: 'Backlink Profile',
      value: 'backlinkProfile',
      active: false,
    },
    {
      text: 'Backlink Relevance',
      value: 'backlinkRelevances',
      active: false,
    },
    {
      text: 'Internal Linking',
      value: 'internalLinking',
      active: false,
    },
    {
      text: 'Technical',
      value: 'technical',
      active: false,
    },
  ];

  public mobileQuery: MediaQueryList;

  public navigationLinksFiltered: any = [
    {
      title: 'Getting Started',
      routerLink: '/seo/getting-started',
      privilege: 'seo_getting_started',
      materialIcon: 'dashboard',
      disabled: true,
    },
    {
      title: 'AI Audit',
      routerLink: '/seo/ai-analysis',
      privilege: 'seo_ai-analysis',
      materialIcon: 'query_stats',
      disable_on_zero_projects: true,
      disabled: false,
      active: true,
    },
    {
      title: 'Content',
      routerLink: '/seo/content',
      privilege: 'seo_content',
      materialIcon: 'text_snippet',
      disable_on_zero_projects: true,
      disabled: true,
    },
    {
      title: 'Rank Tracker',
      routerLink: '/seo/positions',
      privilege: 'seo_position-tracking',
      materialIcon: 'show_chart',
      disable_on_zero_projects: true,
      disabled: true,
    },
    {
      title: 'Backlinks',
      routerLink: '/seo/backlinks',
      privilege: 'seo_backlinks',
      svgIcon: 'link_svg_icon',
      disable_on_zero_projects: true,
      disabled: true,
    },
    {
      title: 'Keywords',
      routerLink: '/seo/keywords',
      privilege: 'seo_projects',
      materialIcon: 'leaderboard',
      disable_on_zero_projects: true,
      disabled: true,
    },
    {
      title: 'Competitors',
      routerLink: '/seo/competitors',
      privilege: 'seo_projects',
      materialIcon: 'groups',
      disabled: true,
    },
    {
      title: 'Projects',
      routerLink: '/seo/projects',
      privilege: 'seo_projects',
      materialIcon: 'format_list_bulleted',
      disabled: true,
    },
    {
      title: 'Integrations',
      routerLink: '/seo/integrations',
      privilege: 'seo_projects',
      materialIcon: 'integration_instructions',
      disabled: true,
    },
  ];

  public horizontalOptionsCategory = [
    {
      value: 'Content Relevance',
      viewValue: 'Content',
      selected: true,
    },
    {
      value: 'Backlink Relevance',
      viewValue: 'Link',
      selected: true,
    },
    {
      value: 'Technical',
      viewValue: 'Site Health',
      selected: false,
    },
  ];
  public horizontalOptionStylesCategory = {
    width: '80px',
    transform: '0px',
  };
  public selected_category: any = 'Content Relevance';
  private overall_fixes_data: any = [];

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') as string;
    sessionStorage.setItem('shareableToken', this.token);
    this.getKeywordsData();
    this.getSearchSuggestedTexts();

    this.keyword_inputSubject.pipe(debounceTime(300)).subscribe((value) => {
      if (value !== this.selected_search_input) {
        this.selected_search_input = value;
        this.getSearchSuggestedTexts();
      }
    });
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('shareableToken');
    this.subs.unsubscribe();
  }

  private apiIndex: number = 0;
  private apiLimit: number = 3;
  private combinedLoader() {
    this.apiIndex++;

    if (this.apiIndex >= this.apiLimit) {
      this.isLoading = false;
      this.firstLoad = false;
      this.apiIndex = 0;
    }
  }

  public getKeywordsData(projChanged = false) {
    this.isLoading = true;
    this.seoService
      .getKeywordsData({
        ...(this.selected_search_input != ''
          ? this.selected_search_option == 'Keyword'
            ? { keyword: this.selected_search_input }
            : { url: this.processUrl(this.selected_search_input) }
          : {}),

        ...(this.selectedModelObj.value != 'view_all'
          ? { model: this.selectedModelObj.value }
          : {}),
      })
      .subscribe(
        (res) => {
          this.selectedProject['domain'] = res['domain'];
          this.keywordData = res;
          this.keywordDataInsights = this.keywordData;

          if (!res['competitor_data'] || res['competitor_data']?.length === 0) {
            this.competitorExists = false;
          } else {
            this.competitorExists = true;
          }

          const formattedData = Object.keys(res.variables)
            .filter(
              (key) =>
                key != 'labels' &&
                key != 'domain' &&
                key != 'date' &&
                key != 'category_summary' &&
                key != 'general_obj'
            )
            .map((key) => ({
              variable: key,
              variables: Object.entries(res.variables[key]).map(
                ([name, value]) => ({
                  name,
                  value,
                  selected: false,
                })
              ),
            }));

          this.renamed_variables = res.renamed_variables;
          this.renamed_variables_2 = res.new_object;
          this.rename_variables_positive = res.rename_variables_positive;

          this.barChartOutputData = {
            variable_labels: res.variable_labels,
            yourScore:
              res.technical_values_per_domain_for_range[
                this.keywordData.domain
              ],
            units: res.units,
            correct_values: res.correct_values,
            renamed_variables: res.renamed_variables,
            rename_variables_positive: res.rename_variables_positive,
            chartData: formattedData,
            date: res.date,
            domain: res.domain,
            labels: res.variables.labels,
            // variables: res.variables,
            variables: Object.keys(res.variables.category_summary).map(
              (key: any) => ({
                name: key,
                value: res.variables.category_summary[key],
              })
            ),
            activeFilter: "All KPI's",
            top_selected: res.top_selected,
          };

          // if (res.competitor_data?.length > 0) {
          //   this.barChartOutputData.category_summary = Object.keys(
          //     this.selectedObject?.category_summary
          //   )?.map((key: any) => ({
          //     name: key,
          //     value: this.selectedObject.category_summary[key],
          //   }));
          //   this.barChartOutputData.competitor_summary = Object.keys(
          //     this.selectedObject.category_summary
          //   ).map((key: any) => ({
          //     name: key,
          //     value: this.selectedObject.category_summary[key],
          //   }));
          //   this.barChartOutputData.selectedCompetitor =
          //     this.selectedObject.domain;

          //   this.selectedCompetitor = this.selectedObject.domain;
          // }

          this.cardsData[0].value = res.variables.overall_mean;
          // if (res.competitor_data.length > 0) {
          //   this.cardsData[0].competitor = this.selectedObject?.overall_mean;
          // }

          this.renamedVariables = res.renamed_variables;
          this.renamedVariables_positive = res.rename_variables_positive;

          for (let i = 0; i < this.barChartOutputData.variables?.length; i++) {
            const cardData = this.cardsData.find((card: any) => {
              return card.name === this.barChartOutputData.variables[i].name;
            });
            if (cardData) {
              cardData['name'] = this.barChartOutputData.variables[i].name;
              cardData['value'] = this.barChartOutputData.variables[i].value;
              cardData['selected'] = false;
              cardData['competitor'] =
                this.barChartOutputData.competitor_summary?.[i]?.value || 0;
              cardData['main_variable_description'] =
                this.keywordData.main_variables_descriptions[
                  this.barChartOutputData.variables[i].name
                ];
            } else {
              this.cardsData.push({
                name: this.barChartOutputData.variables[i].name,
                value: this.barChartOutputData.variables[i].value,
                selected: false,
                competitor:
                  this.barChartOutputData.competitor_summary?.[i]?.value || 0,
                main_variable_description:
                  this.keywordData.main_variables_descriptions[
                    this.barChartOutputData.variables[i].name
                  ],
              });
            }
          }

          const order = [
            "All KPI's",
            'Content Relevance',
            'Backlink Relevance',
            'Backlink Profile',
            'Internal Linking',
            'Technical',
          ];

          this.cardsData.sort((a: any, b: any) => {
            return order.indexOf(a.name) - order.indexOf(b.name);
          });

          // this.cardsData.forEach((card: any) => {
          //   if (card.name == 'Content Relevance' && this.redirectFromContent) {
          //     card['selected'] = true;
          //     this.cardClicked(card);
          //   } else {
          //     card['selected'] = false;
          //   }
          // });

          // remove from display
          const hideFromDisplay = ['Internal Linking'];
          this.cardsData = this.cardsData.filter((card: any) => {
            return !hideFromDisplay.includes(card.name);
          });

          this.showDummyData = false;

          const isAnyCardSelected = this.cardsData.find(
            (card: any) => card.selected
          );
          if (!isAnyCardSelected && this.cardsData[0]) {
            this.cardsData[0].selected = true;
          }

          const generalObj = res?.variables?.general_obj;
          if (generalObj) {
            this.modelCardsData.forEach((card: any) => {
              card.score = generalObj[card.backend_key] || 0;
              card.description = this.modelCardsDataDescriptionMAP.find(
                (item: any) => item.max >= card.score
              )?.description;
            });
            this.siteStrengthOverviewData.forEach((card: any) => {
              card.value = generalObj[card.backend_key] ?? 0;
            });
            this.siteStrengthOverviewData = this.siteStrengthOverviewData.map(
              (card: any) => ({
                ...card,
                description: card.getDescription(),
              })
            );
          }

          this.quick_wins = res?.quick_wins || {};

          this.combinedLoader();
          this.getContentScoresBins();
          this.getBacklinkScoresBins();
          this.constructBarchartData();
        },
        (error) => {
          console.log(error);
          if (!this.firstLoad) {
            this.getTranslatedText('no_data_found', 'phrases').subscribe(
              (translatedText) => {
                this.notificationService.info(translatedText);
              }
            );
          } else {
            this.barChartOutputData = {};
            this.constructBarchartData();
            this.firstLoad = false;
            this.showDummyData = true;
          }
          this.combinedLoader();
          this.combinedLoader();
          this.combinedLoader();
        }
      );
  }

  public constructBarchartData() {
    try {
      let list = [];

      try {
        for (let i = 0; i < this.barChartOutputData.chartData?.length; i++) {
          for (
            let j = 0;
            j < this.barChartOutputData.chartData[i].variables?.length;
            j++
          ) {
            if (this.barChartOutputData.chartData[i].variable != 'Technical') {
              list.push(this.barChartOutputData.chartData[i].variables[j]);
            } else {
              if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'performance_score'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'speedIndex'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'totalByteWeight'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'accessibility_score'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'best_practices_score'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'Time to Interactive'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'Largest Contentful Paint'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
      }

      this.formatted_barchartInputData = list;

      for (let i = 0; i < this.formatted_barchartInputData?.length; i++) {
        this.formatted_barchartInputData[i]['tmp_category'] =
          this.findCategoryName(this.formatted_barchartInputData[i]['name']);
        this.formatted_barchartInputData[i]['random_issue'] =
          this.returnTagPill(this.formatted_barchartInputData[i]['name']);
        this.formatted_barchartInputData[i]['renamed_variable_2'] =
          this.getRenamedVariables(this.formatted_barchartInputData[i]['name']);
      }

      this.formatted_barchartInputData = this.formatted_barchartInputData.sort(
        (a: any, b: any) => {
          if (a['blurElement']) {
            return -1;
          } else if (b['blurElement']) {
            return 1;
          }
          return a.value - b.value;
        }
      );

      this.formatted_barchartInputData =
        this.formatted_barchartInputData.filter(
          (tmp: any) => tmp.tmp_category == 'Content Relevance'
        );

      this.all_formatted_barchartInputData = [
        ...this.formatted_barchartInputData,
      ];

      this.formatted_barchartInputData =
        this.formatted_barchartInputData.splice(0, 4);
    } catch (e) {
      console.log(e);
    }
  }

  public getContentScoresBins() {
    this.subs.add(
      this.seoService
        .getContentScoresBins({
          domain: this.selectedProjectDomain,
          competitor_selected: this.selectedCompetitor,
          lang: this.selectedLanguage,
        })
        .subscribe({
          next: (response) => {
            this.combinedLoader();
            this.constructPageBins(response);
          },
          error: (err) => {
            this.combinedLoader();
            this.constructPageBins(null);
            console.log(err);
          },
        })
    );
  }

  public constructPageBins(data: any) {
    this.page_bins = [];
    this.page_bins_lines = [];

    if (!data || !data?.page_bins || Object.keys(data).length === 0) {
      return;
    }

    function generateScale(
      data: {
        your_value: number;
        competitor_value: number;
        chatgpt_value: number;
        gemini_value: number;
      }[]
    ): number[] {
      // Get the max value across all sources
      const maxValue = Math.max(
        ...data.flatMap((item) => [
          item.your_value || 0,
          item.competitor_value || 0,
          item.chatgpt_value || 0,
          item.gemini_value || 0,
        ])
      );

      // Ensure minimum height for the chart
      const minMax = Math.max(maxValue, 4);

      // Round up to nearest multiple of 2 or 5 or 10 for prettier scales
      let stepBase = 1;
      if (minMax > 20) stepBase = 5;
      else if (minMax > 10) stepBase = 2;

      const topValue = Math.ceil((minMax * 1.1) / stepBase) * stepBase;
      const step = topValue / 4;

      return Array.from({ length: 5 }, (_, i) => Math.round(i * step));
    }

    let maxValue = 0;
    for (let key in data.page_bins) {
      let tmpObj: any = {
        your_value: data.page_bins[key],
        param: [parseInt(key.split('-')[0]), parseInt(key.split('-')[1])],
        name: key,
        selected: false,

        // competitor bins
        ...(this.selectedCompetitor &&
        this.selectedCompetitor != '' &&
        data?.competitor_bins?.[key] != undefined
          ? {
              competitor_value: data?.competitor_bins?.[key],
            }
          : {}),

        // chat gpt bins
        ...(data?.chatgpt_page_bins?.[key] != undefined && {
          chatgpt_value: data?.chatgpt_page_bins?.[key],
        }),

        // gemini bins
        ...(data?.gemini_page_bins?.[key] != undefined && {
          gemini_value: data?.gemini_page_bins?.[key],
        }),
      };

      this.page_bins.push(tmpObj);

      if (data.page_bins[key] > maxValue) {
        maxValue = data.page_bins[key];
      }
      if (data.competitor_bins?.[key] > maxValue) {
        maxValue = data.competitor_bins?.[key];
      }
      if (data.chatgpt_page_bins?.[key] > maxValue) {
        maxValue = data.chatgpt_page_bins?.[key];
      }
      if (data.gemini_page_bins?.[key] > maxValue) {
        maxValue = data.gemini_page_bins?.[key];
      }
    }

    this.page_bins_lines = generateScale(this.page_bins);
    const scaleFactor = Math.max(
      this.page_bins_lines[this.page_bins_lines.length - 1] || 1,
      maxValue
    );

    this.page_bins = this.page_bins.map((item: any) => {
      item['your_percentage'] = parseFloat(
        ((item.your_value / scaleFactor) * 100).toFixed(2)
      );
      if (this.selectedCompetitor && this.selectedCompetitor != '') {
        item['competitor_percentage'] = parseFloat(
          ((item.competitor_value / scaleFactor) * 100).toFixed(2)
        );
      }
      if (item['chatgpt_value'] != undefined) {
        item['chatgpt_percentage'] = parseFloat(
          ((item.chatgpt_value / scaleFactor) * 100).toFixed(2)
        );
      }
      if (item['gemini_value'] != undefined) {
        item['gemini_percentage'] = parseFloat(
          ((item.gemini_value / scaleFactor) * 100).toFixed(2)
        );
      }
      return item;
    });

    if (this.page_bins_lines?.[4] == 0) {
      this.page_bins_lines = [0, 1, 2, 3, 4];
    }

    this.page_bins.forEach((item: any) => {
      item['horizontal_percentage'] =
        this.selectedModel == 'view_all'
          ? item['your_percentage']
          : item[`${this.selectedModel}_percentage`];

      item['horizontal_value'] =
        this.selectedModel == 'view_all'
          ? item['your_value']
          : item[`${this.selectedModel}_value`];
    });
  }

  public getBacklinkScoresBins() {
    this.subs.add(
      this.seoService
        .getBacklinkScoresBins({
          domain: this.selectedProjectDomain,
        })
        .subscribe({
          next: (response) => {
            this.combinedLoader();
            this.constructBacklinkScoresBins(response);
          },
          error: (err) => {
            this.combinedLoader();
            this.constructBacklinkScoresBins(null);
            this.getTranslatedText('something_went_wrong', 'phrases').subscribe(
              (translatedText) => {
                this.notificationService.info(translatedText);
              }
            );
          },
        })
    );
  }

  public constructBacklinkScoresBins(data: any) {
    this.backlink_bins = [];

    if (!data || !data?.bins || Object.keys(data).length === 0) {
      return;
    }

    let maxValue = 0;
    for (let key in data.bins) {
      let tmpObj: any = {
        value: data.bins[key],
        param: [parseInt(key.split('-')[0]), parseInt(key.split('-')[1])],
        name: key,
      };

      this.backlink_bins.push(tmpObj);

      if (data.bins[key] > maxValue) {
        maxValue = data.bins[key];
      }
    }

    let stepBase = 1;
    if (maxValue > 20) stepBase = 5;
    else if (maxValue > 10) stepBase = 2;
    const topValue = Math.ceil((maxValue * 1.1) / stepBase) * stepBase;

    this.backlink_bins = this.backlink_bins.map((item: any) => {
      item['percentage'] = parseFloat(
        ((item.value / topValue) * 100).toFixed(2)
      );
      return item;
    });
  }

  public getSearchSuggestedTexts() {
    const params = {
      domain: this.selectedProject['domain'],
      ...(this.selected_search_option == 'Keyword'
        ? { keyword: this.selected_search_input }
        : { url: this.processUrl(this.selected_search_input) }),

      ...(this.selectedModelObj.value != 'view_all'
        ? { model: this.selectedModelObj.value }
        : {}),
    };

    this.subs.add(
      this.seoService.getSearchSuggestedTexts(params).subscribe((res) => {
        if (this.selected_search_option == 'Keyword') {
          this.selected_search_suggested_texts = res?.topKeywords;
        } else {
          this.selected_search_suggested_texts = res?.topUrls;
        }

        if (res?.topKeywords) {
          this.keyword_input_placehodler = res?.topKeywords?.[0];
        }
        if (res?.topUrls) {
          this.url_input_placehodler = res?.topUrls?.[0];
        }
      })
    );
  }

  public barchartClicked(event: any) {
    this.clickedFactor = event.event?.name;
    this.showNameClickedFactor = event.event?.showName;

    this.backLinkselectedVariable = event.event?.name;

    if (
      this.selectedCard != 'Technical' &&
      this.barChartOutputData.chartData
        .filter((data: any) => data.variable == 'Technical')?.[0]
        ?.variables?.filter((data: any) => data.name == event.event?.name)
        .length == 0 &&
      this.barChartOutputData.chartData
        .filter((data: any) => data.variable == 'Backlink Profile')?.[0]
        ?.variables?.filter((data: any) => data.name == event.event?.name)
        .length == 0
    ) {
      if (
        this.barChartOutputData.chartData
          .filter((data: any) => data.variable == 'Internal Linking')[0]
          .variables.filter((data: any) => data.name == event.event?.name)
          .length == 0
      ) {
        this.showBacklinkOnlyTable = true;
        this.showInternalLinkOnlyTable = false;
        this.backlinkOnlyTableFunction();
      } else {
        if (
          this.backLinkselectedVariable == 'distance' ||
          this.backLinkselectedVariable == 'pr'
        ) {
          this.showInternalLinkOnlyTable = true;
          this.showBacklinkOnlyTable = false;
          this.backlinkOnlyTableFunction();
        } else {
          this.showInternalLinkOnlyTable = false;
          this.showBacklinkOnlyTable = false;
        }
      }
    } else {
      this.showBacklinkOnlyTable = false;
      this.showInternalLinkOnlyTable = false;
    }

    if (this.selectedCard == 'Backlink Relevance') {
      this.backlinkRelevanceTableActive = true;
    } else {
      this.backlinkRelevanceTableActive = false;
    }

    this.cdr.markForCheck();

    this.isFirstExecution = false;
    this.pageIndex = 0;
  }

  private backlinkOnlyTableFunction(redirectToIssue: boolean = false) {
    let tmpSearch = this.selectDomainOption;
    if (tmpSearch == 'Show All') {
      tmpSearch = '';
    }

    this.isLoadingBacklinkTable = true;

    let project = this.selectedProjectDomain;
    if (this.selectedFilterButton == 'competitor') {
      project = this.selectedObject.domain;
    }

    let sort: any;
    if (this.backLinkselectedVariable === 'distance') {
      sort = !this.sortByDistanceTrigger;
    } else if (this.backLinkselectedVariable === 'pr') {
      sort = this.sortByPageRankTrigger;
    } else {
      sort = this.sortByRelevancyScoreTrigger;
    }

    if (this.rankingImpactFilterActive) {
      sort = this.sortByRankingImpactTrigger;
    }

    this.show_ai_score_column = false;

    this.subs.add(
      this.seoService
        .getAnalyseBacklinkValues(
          {
            project: project,
            email: this.selectedProject['email'],
            lang: 'en',
            region: 'United States',
            variables: this.backLinkselectedVariable,
            page: this.pageIndex + 1,
            filterDomain: '',
            pageSize: this.pageSize,
            ...(this.rankingImpactFilterActive
              ? {
                  sortKey: 'AI_score',
                }
              : {}),

            ...(this.selected_search_input != ''
              ? this.selected_search_option == 'Keyword'
                ? { keyword: this.selected_search_input }
                : { url: this.processUrl(this.selected_search_input) }
              : {}),

            ...(this.selectedModelObj.value != 'view_all'
              ? { model: this.selectedModelObj.value }
              : {}),
          },
          sort ? '1' : '0'
        )
        .subscribe({
          next: (res) => {
            this.isLoadingBacklinkTable = false;

            if (this.showInternalLinkOnlyTable) {
              this.internalLinkingDataTable = res['result'];

              try {
                if (this.rankingImpactFilterActive) {
                  if (sort) {
                    this.internalLinkingDataTable =
                      this.internalLinkingDataTable.sort(
                        (a: any, b: any) => a['AI_score'] - b['AI_score']
                      );
                  } else {
                    this.internalLinkingDataTable =
                      this.internalLinkingDataTable.sort(
                        (a: any, b: any) => b['AI_score'] - a['AI_score']
                      );
                  }
                }
              } catch (e) {
                console.log(e);
              }

              this.internalTotalCount = res['total_count'];
              this.constructBacklinkTableData();
            } else {
              this.backlinkOnlyTableData = res['result'];
              this.backlinkTotalCount = res['total_count'];

              this.tableVarianleOne = res['result']?.[0]?.var1;
              this.tableVarianleTwo = res['result']?.[0]?.var2;

              try {
                if (this.rankingImpactFilterActive) {
                  if (sort) {
                    this.backlinkOnlyTableData =
                      this.backlinkOnlyTableData.sort(
                        (a: any, b: any) => a['AI_score'] - b['AI_score']
                      );
                  } else {
                    this.backlinkOnlyTableData =
                      this.backlinkOnlyTableData.sort(
                        (a: any, b: any) => b['AI_score'] - a['AI_score']
                      );
                  }
                }
              } catch (e) {
                console.log(e);
              }

              try {
                if (
                  this.backlinkOnlyTableData[0]['AI_score'] != null &&
                  this.backlinkOnlyTableData[0]['AI_score'] != undefined
                ) {
                  this.show_ai_score_column = true;
                }
              } catch (e) {
                console.log(e);
              }

              this.constructBacklinkTableData(redirectToIssue);
            }

            this.dataSource.data.length = res['total_count'];
            this.dataSource.paginator = this.paginator;
          },
          error: (err) => {
            this.isLoadingBacklinkTable = false;
            console.error(err);
          },
        })
    );
  }

  public onToggleChange(event: any, item: any, customStyles: any) {
    let domOption = event.target.closest('.custom_horizontal_option_select');
    customStyles.width = domOption.clientWidth + 'px';
    customStyles.transform = `translateX(${domOption.offsetLeft}px)`;

    for (let i = 0; i < this.horizontalSingleSelectOptions.length; i++) {
      this.horizontalSingleSelectOptions[i].selected = false;
    }

    item.selected = true;
    this.selectedFilterButton = item.value;

    if (!this.selectedObject) return;

    if (item.value == 'competitor') {
      this.isLoadingBacklinkTable = true;

      this.show_ai_score_column = false;

      this.subs.add(
        this.seoService
          .getAnalyseBacklinkValues(
            {
              // keyword: 'fathers day',
              project: this.selectedObject.domain,
              email: this.selectedProject['email'],
              lang: 'en',
              region: 'United States',
              variables: this.backLinkselectedVariable,
              page: this.pageIndex + 1,
              filterDomain: '',
              pageSize: this.pageSize,
            },
            this.sortByRelevancyScoreTrigger ? '1' : '0'
          )
          .subscribe({
            next: (res) => {
              this.isLoadingBacklinkTable = false;
              if (this.showInternalLinkOnlyTable) {
                this.internalLinkingDataTable = res['result'];
                this.internalTotalCount = res['total_count'];

                this.constructBacklinkTableData();
              } else {
                this.backlinkOnlyTableData = res['result'];
                this.backlinkTotalCount = res['total_count'];

                this.tableVarianleOne = res['result']?.[0]?.var1;
                this.tableVarianleTwo = res['result']?.[0]?.var2;

                try {
                  if (
                    this.backlinkOnlyTableData[0]['AI_score'] != null &&
                    this.backlinkOnlyTableData[0]['AI_score'] != undefined
                  ) {
                    this.show_ai_score_column = true;
                  }
                } catch (e) {
                  console.log(e);
                }

                this.constructBacklinkTableData();
              }

              this.dataSource.data.length = res['total_count'];
              this.dataSource.paginator = this.paginator;
            },
            error: (err) => {
              this.isLoadingBacklinkTable = false;
              console.error(err);
            },
          })
      );
    } else {
      this.backlinkOnlyTableFunction();
    }
  }

  public sortByDistanceTrigger: boolean = false;
  public sortByDistance() {
    this.pageIndex = 0;
    this.sortByDistanceTrigger = !this.sortByDistanceTrigger;
    this.backlinkOnlyTableFunction();
  }

  public sortByPageRankTrigger: boolean = false;
  public sortByPageRank() {
    this.pageIndex = 0;
    this.sortByPageRankTrigger = !this.sortByPageRankTrigger;
    this.backlinkOnlyTableFunction();
  }
  public sortByRelevancyScoreTrigger: boolean = false;
  public sortByRelevancyScore() {
    this.rankingImpactFilterActive = false;
    this.pageIndex = 0;
    this.sortByRelevancyScoreTrigger = !this.sortByRelevancyScoreTrigger;
    this.backlinkOnlyTableFunction();
  }
  public sortByRankingImpactTrigger: boolean = false;
  public rankingImpactFilterActive: boolean = false;
  public sortByRankingImpact() {
    this.rankingImpactFilterActive = true;
    this.pageIndex = 0;
    this.sortByRankingImpactTrigger = !this.sortByRankingImpactTrigger;
    this.backlinkOnlyTableFunction();
  }

  private processUrl = (url: string) => {
    try {
      let cleanUrl = url;
      // Remove 'www.'
      if (cleanUrl.includes('www.')) {
        cleanUrl = cleanUrl.split('www.')[1];
      } else {
        cleanUrl = cleanUrl.split('//')[1];
      }

      // Remove query parameters and fragments
      if (cleanUrl.includes('?')) {
        cleanUrl = cleanUrl.split('?')[0];
      }
      if (cleanUrl.includes('#')) {
        cleanUrl = cleanUrl.split('#')[0];
      }
      if (cleanUrl.includes('&')) {
        cleanUrl = cleanUrl.split('&')[0];
      }

      // Ensure trailing slash
      if (!cleanUrl.endsWith('/')) {
        cleanUrl += '/';
      }

      // Process the path
      cleanUrl = cleanUrl.split('/').slice(1).join('/');

      if (cleanUrl === '') {
        cleanUrl = '/';
      }

      return cleanUrl;
    } catch (error) {
      return url;
    }
  };

  public clearUserSearch() {
    this.selected_search_input_autofill = '';
    this.selected_search_input = '';
    this.keyword_inputSubject.next('');

    this.getKeywordsData();
    this.getSearchSuggestedTexts();
  }

  public filterKeywords(event: any) {
    const value = (event.target as HTMLInputElement).value;
    this.keyword_inputSubject.next(value);
  }

  public getRenamedVariables(variableName: string): void {
    const lang = this.localStorageService.get('language');

    if (lang == 'ja') {
      return (
        this.renamed_variables_2?.[variableName]?.name_japanese || variableName
      );
    } else if (lang == 'de') {
      return (
        this.renamed_variables_2?.[variableName]?.name_german || variableName
      );
    } else {
      return this.renamed_variables_2?.[variableName]?.name || variableName;
    }
  }

  public searchClicked() {
    this.getKeywordsData();
  }

  public formatValue(value: number) {
    if (value === 0) {
      return value.toFixed(0);
    } else if (Math.abs(value) >= 10) {
      return value.toFixed(0);
    } else if (Math.abs(value) < 1) {
      return value.toFixed(2);
    } else if (value % 1 !== 0) {
      return value.toFixed(2);
    } else {
      return value.toFixed(0);
    }
  }

  public constructBacklinkTableData(redirectToIssue: boolean = false) {
    if (this.showInternalLinkOnlyTable) {
      for (let i = 0; i < this.internalLinkingDataTable.length; i++) {
        if (this.internalLinkingDataTable[i]['title']?.length > 120) {
          this.internalLinkingDataTable[i]['show_title'] =
            this.internalLinkingDataTable[i]['title']?.substring(0, 120);
        } else {
          this.internalLinkingDataTable[i]['show_title'] =
            this.internalLinkingDataTable[i]['title'];
        }

        if (
          !this.internalLinkingDataTable[i]['title'] ||
          this.internalLinkingDataTable[i]['title'] == ''
        ) {
          this.internalLinkingDataTable[i]['show_title'] =
            this.internalLinkingDataTable[i]['url']?.substring(0, 120);
          this.internalLinkingDataTable[i]['title'] =
            this.internalLinkingDataTable[i]['url']?.substring(0, 120);
        }
      }
    } else {
      for (let i = 0; i < this.backlinkOnlyTableData.length; i++) {
        this.backlinkOnlyTableData[i]['show_var1_text'] =
          this.backlinkOnlyTableData[i]['var1_text'].substring(0, 60);

        this.backlinkOnlyTableData[i]['show_var2_text'] =
          this.backlinkOnlyTableData[i]['var2_text'].substring(0, 60);

        this.backlinkOnlyTableData[i]['var2_linkfull'] =
          this.backlinkOnlyTableData[i].var2_link;
      }
    }
  }

  public factorChange(data: any) {
    this.filters.filter((filter: any) => filter.active)[0].active = false;

    this.filters.filter((filter: any) => filter.text == data.name)[0].active =
      true;

    this.activeFilter = this.filters.filter(
      (filter: any) => filter.active
    )[0].value;

    this.updateCustomChart();
  }

  public findCategoryName(variable: any) {
    let category = '';
    for (let i = 0; i < this.barChartOutputData.chartData.length; i++) {
      for (
        let j = 0;
        j < this.barChartOutputData.chartData[i].variables.length;
        j++
      ) {
        if (
          this.barChartOutputData.chartData[i].variables[j].name == variable
        ) {
          category = this.barChartOutputData.chartData[i].variable;
          break;
        }
      }
    }
    return category;
  }

  public updateCustomChart(cardChangedSort: boolean = false) {
    if (!this.keywordData) {
      return;
    }

    this.activeFilter = this.cardsData.filter(
      (filter: any) => filter.selected
    )[0].name;

    const formattedData = Object.keys(this.keywordData?.variables)
      .filter(
        (key) =>
          key != 'labels' &&
          key != 'domain' &&
          key != 'date' &&
          key != 'category_summary'
      )
      .map((key) => ({
        variable: key,
        variables: Object.entries(this.keywordData.variables[key]).map(
          ([name, value]) => ({
            name,
            value,
            selected: false,
          })
        ),
      }));

    this.barChartOutputData = {
      variable_labels: this.keywordData.variable_labels,
      yourScore:
        this.keywordData.technical_values_per_domain_for_range[
          this.keywordData.domain
        ],
      units: this.keywordData.units,
      correct_values: this.keywordData.correct_values,
      renamed_variables: this.keywordData.renamed_variables,
      rename_variables_positive: this.keywordData.rename_variables_positive,
      chartData: formattedData,
      date: this.keywordData.date,
      domain: this.keywordData.domain,
      labels: this.keywordData.variables.labels,
      category_summary: Object.keys(
        this.keywordData.variables.category_summary
      ).map((key: any) => ({
        name: key,
        value: this.keywordData.variables.category_summary[key],
      })),
      activeFilter: this.activeFilter,
      selectedCompetitor: this.selectedObject?.domain || '',
      cardChangedSort: cardChangedSort,
      top_selected: this.keywordData.top_selected,
    };

    this.constructBarchartData();
  }

  public constructFixes(data: any) {
    this.overall_fixes_data = data;
    this.content_score_fixes = [];
    this.backlink_score_fixes = [];
    this.quick_wins_array = [];

    data.forEach((item: any, index: number) => {
      if (
        this.quick_wins[item.name] &&
        this.quick_wins_array.length < 3 &&
        item.tmp_category == this.selected_category
      ) {
        this.quick_wins_array.push(this.quick_wins[item.name]);
      }

      if (
        item.tmp_category == this.selected_category &&
        this.content_score_fixes.length < 3
      ) {
        this.content_score_fixes.push(item);
      }
      // else if (
      //   item.tmp_category == 'Backlink Relevance' &&
      //   this.backlink_score_fixes.length < 3
      // ) {
      //   this.backlink_score_fixes.push(item);
      // }
    });

    this.cdr.markForCheck();
  }

  public onToggleChangeCategory(event: any, item: any, customStyles: any) {
    this.openInfoDialog(true);
    // let domOption = event.target.closest('.custom_horizontal_option_select');
    // customStyles.width = domOption.clientWidth + 'px';
    // customStyles.transform = `translateX(${domOption.offsetLeft}px)`;

    // for (let i = 0; i < this.horizontalOptionsCategory.length; i++) {
    //   this.horizontalOptionsCategory[i].selected = false;
    // }

    // item.selected = true;
    // this.selected_category = item.value;
    // this.constructFixes(this.overall_fixes_data);
  }

  public returnTagPill(variable: any) {
    const variableScore =
      this.keywordDataInsights?.variables_scores_mean?.[0]?.[variable];

    if (variableScore) {
      try {
        const value = variableScore.value;
        const rangeVal_1 = parseFloat(variableScore.range?.split('-')?.[0]);
        // const rangeVal_2 = parseFloat(variableScore.range?.split('-')?.[1]);

        if (value < rangeVal_1) {
          return 'Content_mismatch';
        } else {
          return 'Keyword_Overused';
        }
      } catch (e) {
        console.log(e);
      }
    }
    return null;
  }

  public getTranslatedText(
    text: string,
    type: string = 'words'
  ): Observable<string> {
    return this.translate.get(`${type}.${text}`).pipe(
      map((translated: string) =>
        translated === `${type}.${text}` ? text : translated
      ),
      catchError(() => of(text))
    );
  }

  public changeModel(model: any) {
    this.selectedModel = model;
    this.selectedModelObj = this.modelCardsData.find(
      (m: any) => m.value == model
    );
    this.getKeywordsData();
  }

  public formatPercentage(val: any) {
    return (val * 100).toFixed(0);
  }

  public onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.backlinkOnlyTableFunction();
  }

  public onPageChange2(event: any) {
    this.paginator['_pageSize'] = event.value;
    this.onPageChange({ pageSize: event.value, pageIndex: this.pageIndex });
  }

  public formatPageRank(val: any) {
    return parseFloat(val).toFixed(3);
  }

  public openInfoDialog(disabled: boolean) {
    if (!disabled) {
      return;
    }
    this.meetingsDialogRef = this.dialog.open(MeetingsPopupComponent, {
      width: '1000px',
    });
  }

  public openInNewTab(url: string, item?: any): void {
    if (url) {
      if (url.includes(this.selectedProject.domain)) {
        window.open(url, '_blank');
      } else if (url.includes('http:') || url.includes('https:')) {
        window.open(url, '_blank');
      } else {
        const tmpUrl =
          this.selectedProject.url + (url.startsWith('/') ? url : '/' + url);
        window.open(tmpUrl, '_blank');
      }
    }
  }
}
